import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M440-297v-478q0-16 12-28 11-12 28-12t28 12q12 12 12 28v478l210-211q12-12 28-12 17 0 29 12 12 11 11 28 0 16-12 28L508-174q-6 6-13 10-7 3-15 3t-15-3q-7-4-13-10L174-452q-13-13-13-29t13-27q12-12 28-12t27 12l211 211Z"/>',
  f: '<path d="M440-297v-478q0-16 12-28 11-12 28-12t28 12q12 12 12 28v478l210-211q12-12 28-12 17 0 29 12 12 11 11 28 0 16-12 28L508-174q-6 6-13 10-7 3-15 3t-15-3q-7-4-13-10L174-452q-13-13-13-29t13-27q12-12 28-12t27 12l211 211Z"/>',
};

export default data;
